module.exports = __webpack_public_path__ + "static/Nanoleaf-Info-light-265fc5595b828efd5a2f1496b0037e1a.svg";